module.exports = __webpack_public_path__ + "static/media/13.96a81b00.JPG";